module.exports = __webpack_public_path__ + "img/flag_in_hole.96a870e9.gif";